import _ from 'lodash'
import fetch from '~/common/fetch'

// constants
const ADDRESS_COMPARE_EXCLUDE_FIELDS = ['id', 'address_type', 'name']
export const DEFAULT_COUNTRY_CODE = 'USA'

// Helper methods for address components
export const checkFieldErrors = (values, requiredFields) => {
  const newErrors = {}
  Object.keys(requiredFields).forEach(field => {
    if (requiredFields[field] && _.isEmpty(values[field])) newErrors[field] = true
  })
  return newErrors
}

export const compareAddress = (source, toCompare) => {
  const fields = Object.keys(source).filter(f => !ADDRESS_COMPARE_EXCLUDE_FIELDS.includes(f))
  return fields.every(field => source[field] === toCompare[field])
}

export const checkPostalCode = async (countryCode, postalCode, useGlobalPostCodeSetting = true) => {
  if ((countryCode, postalCode)) {
    const result = useGlobalPostCodeSetting
      ? await fetch.get(`/api/v2/country/postal_code/validate?postal_code=${postalCode}&country_code=${countryCode}`)
      : await fetch.get(
          `/api/v2/country/postal_code/validate_post_code?postal_code=${postalCode}&country_code=${countryCode}`
        )
    if (!result.valid) {
      return { valid: false, errors: { zip: result.error } }
    }
  }
  return { valid: true, errors: {} }
}

export const getSubdivisionOptions = async country => {
  const results = await fetch.get(`/api/v2/country-subdivisions/?country__alpha_3_code=${country}&no_page=true`)
  return results.map(s => ({
    value: s.code,
    label: s.subdivision_name
  }))
}

export const getAddressFields = async country => {
  return fetch.get(`/api/v2/country/address_fields/?country__alpha_3_code=${country}&no_page=true`)
}

export const postRequireFieldTransformation = (required, subdivisionOptions) => {
  const updatedRequired = { ...required }
  if (subdivisionOptions.length === 0) {
    delete updatedRequired.state
  } else {
    updatedRequired.state = true
  }

  return updatedRequired
}

export const postErrorTransformation = async (addressData, requiredFields, useGlobalPostCodeSetting = true) => {
  const updatedErrors = checkFieldErrors(addressData, requiredFields)
  const omittedErrors = _.omit(updatedErrors, Object.keys(addressData))
  const { errors } = await checkPostalCode(addressData.country_code, addressData.zip, useGlobalPostCodeSetting)

  return { ...updatedErrors, ...omittedErrors, ...errors }
}
